
    import { mapGetters } from "vuex"
    import getters from "@/store/getters"
    import { ICategory } from "@/types"
    import { defineComponent, PropType } from "vue"
    import InputText from "./misc/InputText.vue"

    export default defineComponent({
        props: {
            category: Object as PropType<ICategory>,

        },
        components: {
            InputText,

        },
        // emits: ['update:modelValue'], this.$emit('update:modelValue', title)
        data() {
            return {
                name: this.category?.name,
                rename: false,
                getters
            }
        },
        computed: {
            ...mapGetters(["isModer"]),

        },
        methods: {
            activate() {
                if (!this.rename) {
                    this.$emit("select")
                }
            },

            toggleRename() {
                if (this.rename) {
                    this.$emit("update", { field: "name", value: this.name })
                    this.rename = false
                } else {
                    this.rename = true
                }
            },

        },
    })

    